export * from "./useGetProjectScenarios";
export * from "./useGetScenarios";

// export { default as useGetScenarios } from "./useGetScenarios";
export { default as useDeleteScenario } from "./useDeleteScenario";
